import { createSlice } from "@reduxjs/toolkit";
import { CampaignsActivitySlice } from "types/campaign/activity";
import { fetchCampaignsActivityThunk } from "./thunk";

const initialState: CampaignsActivitySlice = {
    filters: {
        page: 1
    },
    applied_filter_id: null,
    filtered_lists: {},
    loading: false,
    error: null,
    total: 0
}

const campaignsActivity = createSlice({
    name: 'campaignsActivity',
    initialState,
    reducers: {
         updateCampaignsActivityFilters: (state, action) => {
            state.filters = action.payload;
        }
        
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCampaignsActivityThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCampaignsActivityThunk.fulfilled, (state, {payload}) => {
                state.loading = false;
                state.error = null;
                const { filterId, filters, count, items } = payload;
                const existingList = state.filtered_lists?.[filterId]?.list ?? [];
                const list = filters.page === 1 ? items : [...existingList, ...items]
                state.filtered_lists = {
                    ...state.filtered_lists,
                    [filterId]: {
                        list,
                        page: filters.page,
                        expired: false,
                        last_fetched_at: Date.now(),
                        has_more: count > list.length,
                        count
                    }
                }
                state.applied_filter_id = filterId
            })
            .addCase(fetchCampaignsActivityThunk.rejected, (state) => {
                state.loading = false;
            })
    }
})

export const { updateCampaignsActivityFilters } = campaignsActivity.actions;

export const campaignsActivityReducer = campaignsActivity.reducer;